import styled from 'styled-components';
import {formBlock} from 'styles/fragments';

export default styled.div`
	${formBlock};
`;
